<div class="alert__wrapper">
	<div class="alert__header">
		{{'update_text_www' | translate:systemLanguage}}
	</div>
	<div class="alert__buttons">
		<button mat-flat-button (click)="acceptAndClose()">{{'execute' | translate:systemLanguage}}</button>
		<button mat-flat-button (click)="close()">{{'cancel' | translate:systemLanguage}}</button>
	</div>
</div>
